import clsx from "clsx";

import { handleGoogleDriveImageUrl } from "../../../shared/utils";
import { PairType } from "../../widget.types";

export function MatchUpCard({
  imageLink,
  index,
  brandLogo,
  onCardClick,
  close,
  complete,
  wrongPair,
}: PairType & {
  index: number;
  brandLogo: string;
  onCardClick: () => void;
  close: boolean;
  complete: boolean;
  wrongPair: boolean;
}) {

  return (
    <div
      role="button"
      tabIndex={index}
      className={clsx(
        "match-up--card",
        !close && "opened",
        complete && "matched",
        wrongPair && "wrong"
      )}
      onClick={onCardClick}
    >
      <div className="match-up--card-side front">
        <img
          src={handleGoogleDriveImageUrl(brandLogo || "")}
          alt={"Brand logo"}
        />
      </div>
      <div
        className="match-up--card-side back"
        style={{
          backgroundImage: `url(${handleGoogleDriveImageUrl(imageLink || "")})`,
        }}
      />
    </div>
  );
}
